// src/api/roleService.ts
import { apiService } from './apiService';

export interface RoleDefinition {
  id: string;
  roleName: string;
  description: string;
  createdBy?: string;
  isAdmin: boolean;
  isActive: boolean;
  isImported: boolean;
  isExternal: boolean;
  roleSource: number;
  totalUsers: number;
}

/** Payload for POST /api/auth/roles/create — server sets TenantId, CreatedBy, etc. */
export interface CreateRoleRequest {
  roleName: string;
  description: string;
  isAdmin: boolean;
  isActive: boolean;
}

/** Payload for POST /api/auth/roles/edit */
export interface EditRoleRequest {
  id: string;
  roleName: string;
  description: string;
  isAdmin: boolean;
  isActive: boolean;
}

const mapRole = (r: any): RoleDefinition => ({
  id: String(r.id ?? r.roleId ?? ''),
  roleName: String(r.roleName ?? r.title ?? ''),
  description: String(r.description ?? ''),
  createdBy: r.createdBy ?? r.createdby ?? undefined,
  isAdmin: !!(r.isAdmin ?? r.isadmin),
  isActive: r.isActive ?? r.isactive ?? true,
  isImported: !!(r.isImported ?? r.isimported),
  isExternal: !!(r.isExternal ?? r.isexternal),
  roleSource: Number(r.roleSource ?? r.rolesource ?? 0),
  totalUsers: Number(r.totalUsers ?? r.assignedUsers?.length ?? 0),
});

export const roleService = {
  getRolesWithUsers: () =>
    apiService.get('/api/auth/roles/users', {}, 'backend'),

  getRoleDefinitions: async (): Promise<RoleDefinition[]> => {
    const response = await apiService.get('/api/auth/roles/users', {}, 'backend');
    return (Array.isArray(response) ? response : []).map(mapRole);
  },

  /** POST /api/auth/roles/create → { roleId } */
  createRole: (data: CreateRoleRequest) =>
    apiService.post(
      '/api/auth/roles/create',
      {
        roleName: data.roleName,
        description: data.description,
        isAdmin: data.isAdmin,
        isActive: data.isActive,
      },
      'backend'
    ),

  /** POST /api/auth/roles/edit → 204 No Content */
  updateRole: (data: EditRoleRequest) =>
    apiService.post(
      '/api/auth/roles/edit',
      {
        id: data.id,
        roleName: data.roleName,
        description: data.description,
        isAdmin: data.isAdmin,
        isActive: data.isActive,
      },
      'backend'
    ),

  deleteRole: (id: string) =>
    apiService.post('/api/auth/roles/delete', { id }, 'backend'),
};
